export const TEACHER_LAYOUT = {
    "sidebar": "sidebar_layout",
    "content": "content_layout"
}

export const FAQ_TYPES = {
    UNDER_REVIEW: "under_review",
    REASSESS: "reassess",
    UNSCORABLE_TEST: "unscoreable_test",
    EARLY_NEXT_BUTTON: "early_next_button",
    NOT_TRYING: "not_trying",
    MINIMUM_SCORING: "minimum_scoring",
    LOOKS_WRONG: "looks_wrong",
    YELLOW_FLAG: "yellow_flag",
    YELLOW_FLAG_PRACTICE: "yellow_flag_practice",
    INCONSISTENT_TIME: "inconsistent_time",
}